exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".default-redirect-checkbox {\n  margin-right: 5px;\n  margin-top: 0 !important;\n  display: inline-block;\n  vertical-align: middle;\n  cursor: pointer; }\n\n.permission-item-container {\n  display: flex;\n  align-items: center;\n  gap: 5px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/users/users.scss
// module id = 1187
// module chunks = 1